import { render, staticRenderFns } from "./titlesectionlist.vue?vue&type=template&id=ba343a84"
import script from "./titlesectionlist.vue?vue&type=script&lang=js"
export * from "./titlesectionlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports